import React from "react";
import Title from "../../../components/Title/Title";

const SocialActivities2027page = () => {
    return (
        <div>
            <Title>Social Activities</Title>
            <p>[COMING SOON]</p>
        </div>
    )
}

export default SocialActivities2027page
